// Las llaves preliminares conservan su prefijo en consultas y envíos.
export const isConcessionResponseKey = (value) => /^(?:PRE_)?\d{10}$/.test(String(value || ""));
